export const OptionItem = ({ name, origin }: { name: string; origin: string }) => {
    if (!name || !origin) return null;
    return (
        <div className="value">
            {name} {origin}
        </div>
    );
};
